import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { authActions } from "../../redux/store";
import toast from "react-hot-toast";
import TokenValidator from "../../fetchdata/TokenValidator";
import Cart from "./Cart";
import { useBlogContext } from "../../fetchdata/BlogContext";
import $ from "jquery";
import { Helmet } from "react-helmet";

import getCookie from "../../helper/getCookie";
import eraseCookie from "../../helper/eraseCookie";
import CreateSlug from "./extra/CreateSlug";

import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import LiveRequest from "./LiveRequest";



const MenuItem = ({ item }) => {
  return (
    <li key={item.id} className={item.children ? "has_submenu" : ""}>
      {item.children && item.children.length > 0 ? (
        <>
          <span>
            <Link
              to={item.link.replace('{{id}}', (localStorage.getItem('location') !== "[object Object]" && localStorage.getItem('location')) ? localStorage.getItem('location') : "delhi" )} 
              target={item.target === "_blank" ? "_blank" : ""}
            >
              {item.text}
            </Link>
            <i class="ti ti-chevron-right"></i>
          </span>
          <SubMenu items={item.children} />
        </>
      ) : (
        <Link   
          to={item.link.replace('{{id}}', (localStorage.getItem('location') !== "[object Object]" && localStorage.getItem('location')) ? localStorage.getItem('location') : "delhi" )} 
           target={item.target === "_blank" ? "_blank" : ""}>
          {item.text}
        </Link>
      )}
    </li>
  );
};

const SubMenu = ({ items }) => {
  return (
    <ul className="submenu">
      <li>
        <span className="mobile_menu_back">
          <i class="ti ti-chevron-left"></i> Back
        </span>
      </li>
      {items.map((child) => (
        <MenuItem key={child.id} item={child} />
      ))}
    </ul>
  );
};

const Header = () => {

  const navigate = useNavigate();

  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      function (position) {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
  
        // Save to localStorage
        localStorage.setItem("userLatitude", latitude);
        localStorage.setItem("userLongitude", longitude);
  
        console.log("Location saved");
      },
      function (error) {
        console.log("Location error:", error);
      }
    );
  }

  
     const driverObj = driver({
      showProgress: true,
      theme: 'yellow',  // Set the theme to yellow
      steps: [
        { element: '#searchInput', popover: { title: 'Select Location', description: 'Please choose your location to proceed.', side: "left", align: 'start' }},
       
      ]
    });
  
    useEffect(() => {
      const location = localStorage.getItem('location');
      if( location !== "[object Object]" && location){
        // navigate(`/loc/${location}`)
      }else{
       driverObj.drive();

      }
     }, []);
  
  
  
  const location = useLocation();

  const [user, setUser] = useState(null);

  const [showSearch, setShowSearch] = useState("false");
  const toggleSearch = () => {
    setShowSearch(!showSearch);
  };


  const {
    Headers,
    isHeader,
    cartItems,
    AllProducts,
    AllCategoriess,
    isLayoutLoading,
    LocationHeaders,
    layout,
  } = useBlogContext();
  if (isHeader) {
    // console.log("Headers", Headers);
  }

  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const toggleSubMenu = (event) => {
    const submenu = event.target.nextElementSibling;
    submenu.classList.toggle("open");
  };

  const goBack = (event) => {
    const parentSubMenu = event.target.closest(".submenu");
    parentSubMenu.classList.remove("open");
  };


  useEffect(() => {
    $("#mobile_menu_container").removeClass("open");
    const storedUser = JSON.parse(getCookie("user"));
    setUser(storedUser);
  }, [location.pathname]);

  useEffect(() => {
    window.scrollTo(0, 0);

    $("#mobile_menu_trigger").click(function () {
      $("#mobile_menu_container").toggleClass("open");
    });

    $("#mobile_menu_trigger_mob").click(function () {
      $("#mobile_menu_container").toggleClass("open");
    });

    $("#mobile_menu_container, .mobile_menu_close, .mobile_menu_close i").on(
      "click",
      function (e) {
        if (e.target === this) {
          $("#mobile_menu_container").toggleClass("open");
          /* $('#mobile_menu_container_inner').toggleClass('open'); */
        }
      }
    );

    $(document).on("click", "#mobile_menu .has_submenu > span", function () {
      $("+ .submenu", $(this)).addClass("open");
    });

    $(document).on("click", "#mobile_menu .sub_sub_menu > span", function () {
      $("+ ul", $(this)).addClass("open");
    });

    $(document).on("click", "#mobile_menu .mobile_menu_back", function () {
      $(this).closest("ul").removeClass("open");
    });
  }, []);

  const [searchQuery, setSearchQuery] = useState("");
  const [SearchShow, setSearchShow] = useState(false);
  const handleFocus = () => {
    setSearchShow(true); // Update state when input is focused
  };
  const handleInputChange = (e) => {
    setSearchQuery(e.target.value);
    console.log('e.target.value',e.target.value)
  };

  const handleClearClick = (value) => {
     
 
    const locationData = localStorage.getItem('location');
const locSlug = locationData ? CreateSlug(locationData) : null;

    const currentPath = location.pathname; // e.g., /delhi/anypage
    const pathSegments = currentPath.split('/');
   
    const locLiveSlug = pathSegments.find(segment => segment.trim()); // finds "gumia"
    const cleanLocLiveSlug = locLiveSlug?.trim(); // final cleaned slug
    
console.log('currentPath locSlug ', cleanLocLiveSlug , locSlug ,value)
    if(cleanLocLiveSlug === locSlug &&  (!Array.isArray(value) && typeof value !== 'object' || value === null) ){

      //  Replace the first segment if it's a location
    if (pathSegments.length > 1) {
      pathSegments[1] = CreateSlug(value.toLowerCase()); // set new location
    }
    const updatedPath = pathSegments.join('/');
    console.log('livepath ', updatedPath )

    //  window.location.href = updatedPath;
    navigate(updatedPath)

    }else{
      const fvalue = CreateSlug(value);
      
      if( fvalue == 'object-object'){
        navigate(`/`)
      }else{
        navigate(`/${CreateSlug(value)}`)
      }
    }
 

    setSearchQuery("");
    setSearchShow(false);
     if(value){
      localStorage.setItem('location', value);
    }
  };
  



  // const filteredLocations = LocationHeaders.filter((zone) => {
  //   // Check if the state name or any of its cities contains the search query
  //   return (
  //     zone.name.toLowerCase().includes(searchQuery.toLowerCase())
  //   );
  // });

  const filteredLocations = LocationHeaders.filter((location) =>
    location.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const [isStuck, setIsStuck] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsStuck(true);
      } else {
        setIsStuck(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); // Empty dependency array ensures that this effect runs only once after initial render

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen); // Toggle the value of isMenuOpen
  };

  // const isLogin = useSelector(state => state.isLogin)
  // console.log(isLogin)

  const dispatch = useDispatch();
  //state
  const [value, setValue] = useState();

  // const isLoginFromLocalStorage = localStorage.getItem("token") ? true : false;
  const isLoginFromLocalStorage = getCookie("token") ? true : false;
  const [isLogin, setIsLogin] = useState(isLoginFromLocalStorage);

  useEffect(() => {
    setIsLogin(isLoginFromLocalStorage);
  }, [isLoginFromLocalStorage]);

  //logout
  const handleLogout = () => {
    try {
      dispatch(authActions.logout());
      toast.success("Logout Successfully");
      navigate("/login");
      localStorage.clear();
      eraseCookie("token");
      eraseCookie("userId");
      eraseCookie("user");
      //  localStorage.removeItem("token");
      // localStorage.removeItem("userId");
      // localStorage.removeItem("user");
    } catch (error) {
      console.log(error);
    }
  };
  const [isCartActive, setCartIsActive] = useState(false);

  const toggleCartClass = () => {
    setCartIsActive(!isCartActive);
  };


  return (
    <>
<LiveRequest/>
<nav className="osahan-nav navbar navbar-expand-lg bg-white py-0 border-bottom ">
  <div className="container">
    <a
      className="navbar-brand fw-bold d-flex align-items-center gap-2 text-dark"
      href="/"
    >
         <Link to="/" className="navbar-brand logo"  >
                       {Headers.meta_logo && Headers.meta_logo !== undefined ? (
                         <img
                           src={Headers.meta_logo}
                           width={120}
                           alt="logo"
                           style={{ maxHeight: 40, width: "auto" }}
                         />
                       ) : (
                         <div
                           className="card-1 skeleton"
                           style={{ borderRadius: 5, aspectRatio: "35/8",height:40 }}
                         ></div>
                       )}
                     </Link> 
    </a>
    <button
      className="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span className="navbar-toggler-icon" />
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      {/* <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
        <li className="nav-item dropdown">
          <a
            className="nav-link text-dark "
            href="/"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Home
          </a>
        </li>
        <li className="nav-item dropdown">
          <a
            className="nav-link text-dark"
            href="/category.php"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Services
          </a>
      
        </li>
        <li className="nav-item dropdown">
          <a
            className="nav-link text-dark dropdown-toggle"
            href="#"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            My Account
          </a>
          <ul className="dropdown-menu shadow">
            <li>
              <a className="dropdown-item" href="/edit-profile.php">
                Edit Profile
              </a>
            </li>
            <li>
              <a className="dropdown-item" href="/my-booking.php">
                My Bookings
              </a>
            </li>
            <li>
              <a className="dropdown-item" href="/history.html">
                History
              </a>
            </li>
            <li>
              <a className="dropdown-item" href="/notification.html">
                Notification
              </a>
            </li>
          </ul>
        </li>
        <li className="nav-item dropdown">
          <a
            className="nav-link text-dark dropdown-toggle"
            href="#"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Pages
          </a>
     
        </li>
        <li className="nav-item">
          <a className="nav-link" href="/contact">
            Contact
          </a>
        </li>
      </ul> */}

<div className="col-lg-3 col-12 pe-lg-1 position-relative">
                <div className="input-group  rounded-pill shadow-sm overflow-hidden bg-light border "  >
      <span className="input-group-text bg-transparent border-0 rounded-0 py-2 px-3 pe-2">
                    <i className="bi bi-geo-alt-fill  h5 m-0" />
                  </span>
      <input
                                id="searchInput"
                                className="form-control bg-transparent searchinput px-2 py-2 border-0 shadow none ps-0 "
                                type="text"
                               
                                placeholder={localStorage.getItem('location') !== "[object Object]" && localStorage.getItem('location') ? localStorage.getItem('location') : "Search for state and cities"}
                                value={searchQuery  }
                                onChange={handleInputChange}
                                onFocus={handleFocus} // Call handleFocus when the input is focused
                                autoComplete="off" // Disable browser suggestions
                                defaultValue={localStorage.getItem('location')}
                                />
                               
                                 {(searchQuery ||SearchShow ) && (
                                <>
                                  <button
                                    type="button"
                                    className="btn bg-transparent d-none d-lg-block close p-0 pe-3"
                                    onClick={handleClearClick}
                                  >
                                    {" "}
                                     <i className="navbar-actions-icon bi bi-x-lg fw-bold"></i>
                                  </button>
                                </>
                              )}
                              
                              </div>
            
                              { (searchQuery || SearchShow ) && (
                                <>
                                  <ul className="searchfloat">
            
                                  {filteredLocations.length > 0 ? (
                      filteredLocations.map((item) => {
                        const stateSlug = CreateSlug(item);
            
                        return (
                          <li key={item}>
                            {/* State option */}
                            <a type="button" className="bg-transparent border-0" onClick={() => handleClearClick(item)}>
                            <i className="ri-map-pin-2-fill"></i>  {item}
                            </a>
             
                          </li>
                        );
                      })
                    ) : (
                      <li className="p-3">No matching results</li>
                    )}
            
                              </ul>
                              </>
                            )}
            

 
              </div>
              
      <ul className="navbar-nav ms-auto mb-2 mb-lg-0 align-items-center">
  {isHeader
    ? Array.from({ length: 5 }).map((_, index) => (
        <li className="nav-item" key={index}>
          <div
            className="skeleton my-4"
            style={{ height: 28, width: 80, borderRadius: 5 }}
          ></div>
        </li>
      ))
    : Headers.header &&
      Headers.header.slice(0, 10).map((item) => (
        <li
          className={`nav-item ${
            item.children && item.children.length > 0 ? "dropdown" : ""
          }`}
          key={item.id}
        >
          <Link
            className={`nav-link text-dark ${
              item.children && item.children.length > 0 ? "dropdown-toggle" : ""
            }`}
            to={
              item.children && item.children.length > 0 ? "#" : item.link || "/"
            }
            role="button"
            {...(item.children &&
              item.children.length > 0 && {
                "data-bs-toggle": "dropdown",
                "aria-expanded": "false",
              })}
          >
            {item.text}
          </Link>

          {/* First-level Dropdown */}
          {item.children && item.children.length > 0 && (
            <ul className="dropdown-menu shadow">
              {item.children.slice(0, 50).map((child) => (
                <li key={child.id || child.link}>
                  <Link
                    className="dropdown-item"
                     to={child.link.replace('{{id}}', (localStorage.getItem('location') !== "[object Object]" && localStorage.getItem('location')) ? localStorage.getItem('location') : "delhi" )} 

                    target={child.target === "_blank" ? "_blank" : ""}
                  >
                    <b>{child.text}</b>
                  </Link>

                  {/* Second-level Nested Dropdown */}
                  {child.children && child.children.length > 0 && (
                    <ul className="widget-list ps-3">
                      {child.children.slice(0, 20).map((subChild) => (
                        <li
                          className="widget-list-item"
                          key={subChild.id || subChild.link}
                        >
                          <Link
                            className="widget-list-link"
                            to={subChild.link}
                            target={subChild.target === "_blank" ? "_blank" : ""}
                          >
                            {subChild.text}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          )}
        </li>
      ))}



    {isLogin && (
              <> 
        <li
          className={`nav-item dropdown mx-0`}
           
        >   <ul className="widget-list ps-3" >

        

            <li className="nav-item dropdown d-block ">
  <a
    className="nav-link text-dark dropdown-toggle btn-primary text-white px-3 py-2 border rounded"
    role="button"
    data-bs-toggle="dropdown"
    aria-expanded="false"
    href="/account"
  >
    My Account
  </a>
  <ul className="dropdown-menu shadow">
    <li>
      <Link className="dropdown-item" to={'/account/profile'} >
        <b>Edit Profile</b>
      </Link>
    </li>
    <li>
      <Link className="dropdown-item" to={'/account/all-order'} >
        <b>My Bookings</b>
      </Link>
    </li>
      <li>
      <Link className="dropdown-item" onClick={handleLogout} type="button" >
        <b>Logout</b>
      </Link>
    </li>
    
  </ul>
</li>
 
      </ul>
      
      </li>

 </> 
            )}

 <li className="nav-item d-block pt-3">
  <Link to="/cart"   className="nav-link text-dark dropdown-toggle text-white p-0" >
                    <div className="navbar-actions-icon-box position-relative">
                      <svg
                        style={{ width: 30, height: 30 ,fill:'#0072d9'}}
                        xmlns="http://www.w3.org/2000/svg"
                        data-name="Your Icons"
                        viewBox="0 0 48 48"
                      >
                        <path d="M12.11 44h23.78A4 4 0 0 0 40 39.6l-2.26-22a4.07 4.07 0 0 0-4.11-3.6H32v-2a8 8 0 0 0-16 0v2h-1.63a4.07 4.07 0 0 0-4.09 3.6L8 39.6a4 4 0 0 0 4.11 4.4ZM18 12a6 6 0 0 1 12 0v2H18Zm-5.73 5.81a2.07 2.07 0 0 1 2.1-1.81H16v2.89a1.5 1.5 0 1 0 2 0V16h12v2.89a1.5 1.5 0 1 0 2 0V16h1.63a2.07 2.07 0 0 1 2.1 1.81l2.26 22a1.89 1.89 0 0 1-.5 1.49 2.16 2.16 0 0 1-1.6.7H12.11a2.16 2.16 0 0 1-1.6-.7A1.93 1.93 0 0 1 10 40h24a1 1 0 0 0 0-2H10.2Z" />
                      </svg>

                      {cartItems.length > 0 && (
                      <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"> {cartItems.length}</span>
                    )}
                    </div>
                     
                    </Link>
     </li>


      
</ul>



      <div className="ms-3">
             {!isLogin && (
              <>  <Link
              to={'/login'}
          className="btn btn-primary"
        
        >
          Login/Sign Up
        </Link>
        </> )}
       
      </div>
    </div>
  </div>
</nav>



      <div id="mobile_menu_container" className="">
           <div id="mobile_menu_container_inner">
             <div className="mobile_menu_top">
               <Link to="/">
                 {Headers.meta_logo && Headers.meta_logo !== undefined ? (
                   <img
                     src={Headers.meta_logo}
                     width={120}
                     alt="logo"
                     style={{ maxHeight: 50, width: "auto" }}
                   />
                 ) : (
                   <div
                     className="card-1 skeleton"
                     style={{ borderRadius: 5, aspectRatio: "300/42" }}
                   ></div>
                 )}
               </Link>
               <div className="mobile_menu_close">
                  <i class="ti ti-x"></i>
               </div>
             </div>
             <div id="mobile_menu_image_links"></div>
 
             <ul id="mobile_menu">
               {Headers.header &&
                 Headers.header.length > 0 &&
                 Headers.header.map((item) => (
                   <MenuItem key={item.id} item={item} />
                 ))}
 
               {/* 
               <li className="has_submenu">
                 <Link to="/allblogs">All Blogs</Link>
               </li>
 
               {isLogin ? (
                 <>
                   <li className="has_submenu">
                     <Link to="/account">Account</Link>
                   </li>
 
                   <li className="has_submenu">
                     <Link to="/wishList">Wishlist</Link>
                   </li>
 
                   <li className="has_submenu">
                     <Link to="/comparsion">Comparsion</Link>
                   </li>
 
                   <li className="has_submenu">
                     <Link onClick={handleLogout}>Logout</Link>
                   </li>
                 </>
               ) : (
                 <>
                   <li className="has_submenu">
                     <Link to="/comparsion">Login / Signup</Link>
                   </li>
                 </>
               )} 
                */}


             </ul>
           </div>
         </div>
 
 
    </>
  );
};

export default Header;
